<!--  -->
<template>
  <div :class="['newAdress', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title :titleName="title" :zIndex="1000" :bcColor="'#F9F9F9'" @goBack="goBack"></common-title>
    <!-- 订单地址 -->
    <template>
      <OrderAddress ref="ordeRef" :chooseIndex="chooseIndex" @chooseAddress="chooseNewAddress" :source="source" />
    </template>

    <div class="newAdress-body">
      <h2 class="adressTitle" v-if="Number(source) === 1">新增地址</h2>
      <van-form ref="formData" @submit="onSubmit">
        <div class="content">
          <van-field class="first-field" v-model.trim="ruleForm.userName" name="name" label="收货人" placeholder="收货人" />
          <van-field v-model.trim="ruleForm.phone" type="tel" name="phone" label="手机号码" placeholder="手机号码" />
          <van-field readonly clickable :value="ruleForm.local" right-icon="arrow" name="local" label="所在地区"
            placeholder="点击选择省市区" @click="showArea = true" />
          <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
          </van-popup>
          <van-field class="four-field" v-model.trim="ruleForm.address" rows="1" autosize type="textarea" clearable
            name="address" label="详细地址" placeholder="详细地址" />
        </div>
        <!-- <div class="division"></div> -->
        <div class="default" style="display: none">
          <!-- <van-field name="type" label="设置默认地址"  input-align="right">
          <template #input>
            <van-switch v-model="ruleForm.type" :active-value="1" :inactive-value="0" size="20" active-color="#FF791B" />
          </template>
        </van-field> -->
          <van-radio-group v-model="ruleForm.type">
            <!-- <van-radio
              name="1"
              v-if="this.ruleForm.type==1"
            >
              设置默认地址
              <template #icon="">
                <img
                  class="img-icon"
                  :src="activeIcon"
                  @click="checkDefault(0)"
                />
              </template>
            </van-radio> -->

            <!--
              v-if="this.ruleForm.type==0"
             -->
            <van-radio :name="ruleForm.type">
              设置默认地址
              <template #icon="">
                <img class="img-icon" :src="ruleForm.type == 1 ? activeIcon : inactiveIcon"
                  @click="checkDefault(ruleForm.type === 0 ? 1 : 0)" />
              </template>
            </van-radio>
          </van-radio-group>
        </div>
        <div class="footer">
          <van-button round block type="info" :loading="loading" loading-text='保存并使用' native-type="submit">确定</van-button>
          <!-- <button class="button" @click="save">保存并使用</button> -->
        </div>
      </van-form>
    </div>
    <template>
      <AddressList ref="historyRef" @chooseAddress="chooseNewAddress" :newAddressFlag='newAddressFlag'
        :delCheck='delCheck' :chooseIndex='chooseIndex' :oldChoose='oldChoose' :source="Number(source)" />
    </template>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqAddressList, reqAddAddress, reqModifyAddress, reqAddDakaAddress, reqAddPullNewAddress } from '@/api/personal/addressController';

import { reqWaitDeliver, reqModifyReceivingAddress, reqAddGiftAddress } from '@/api/personal/logistics/index';
import { reqIndentAddress } from '@/api/personal/orderController';
import { Throttle } from '@/utils/tools';

// eslint-disable-next-line import/extensions
import AddressList from './historyAddress';
import OrderAddress from './orderAddress';
import { areaList } from '@vant/area-data';

export default {
  data() {
    return {
      ruleForm: {
        userName: '',
        phone: '',
        local: '',
        address: '',
        type: 0,
      },
      myAddressProvince: '',
      myAddressCity: '',
      myAddresscounty: '',
      value: '',
      areaList,
      showArea: false,
      change: false, // 判断是否修改或新增
      addressCopy: {},
      title: '填写收货地址',
      isClick: true, // 防止多次点击设定
      isClickCopy: true,
      loading: false,
      oldAddressId: '',
      newAddressFlag: false,
      activeIcon: require('@/assets/img/personalCenter/checkact.png'),
      inactiveIcon: require('@/assets/img/personalCenter/nocheckact.png'),
      delCheck: false, // 列表勾选
      isChoose: false, // 是否签署了协议
      wiatNum: 0,
      isfromPath: false,
      defauleAddress: [],
      chooseIndex: -1,
      oldChoose: -1,
      watchFrom: {
        userName: '',
        phone: '',
        local: '',
        address: '',
        type: 0,
      },
      newFromval: {},
      directlyChange: false, // 直接修改地址(已存在地址不用新增)
      show: false, // 弹出层展示
      source: 0,
    };
  },

  components: {
    CommonTitle,
    AddressList,
    OrderAddress,
  },

  computed: {
    // ...mapState(['addressInfo']),
  },
  watch: {
    // ruleForm: {
    //   immediate: true,
    //   handler(val) {
    //     // this.newFromval = val;
    //     console.log(val, 'ruleFormruleForm');
    //   },
    //   // deep: true, // 对象的深度验证
    // },
  },
  activated() {
    if (this.isfromPath) {
      this.addressDefaultList();
    }
    this.source = Number(this.$route?.query?.sourse || 0);
  },
  created() {
    if (this.$route.query.type === 'amend') {
      const addressInfo = JSON.parse(sessionStorage.getItem('saveAddressInfo'));
      // const { addressInfo } = this;
      this.ruleForm = addressInfo;
      this.ruleForm.local = `${addressInfo.province} ${addressInfo.city} ${addressInfo.area}`;
    }
  },

  mounted() {
    this.getWaitDeliver();
    this.tangLangInit();
  },

  methods: {
    checkDefault(val) {
      this.ruleForm.type = val;
    },
    onSubmit() {
      this.submitForm();
    },
    save() {
      this.$refs.formData.onSubmit();
    },
    // 拆分地址省市区
    splitArea(data) {
      const array = data.split(' ');
      const a1 = array[0];
      const a2 = array[1];
      const a3 = array[2];
      this.myAddressProvince = a1;
      this.myAddressCity = a2;
      this.myAddresscounty = a3;
    },
    // 省市区选择器弹窗的确认
    onConfirm(values) {
      this.ruleForm.local = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(' ');
      this.showArea = false;
    },
    isObjectChanged(source, comparison) {
      // eslint-disable-next-line no-underscore-dangle
      const _source = JSON.stringify(source);
      // eslint-disable-next-line no-underscore-dangle
      const _comparison = JSON.stringify({ ...source, ...comparison });
      return _source !== _comparison;
    },
    // 校验信息
    async submitForm() {
      if (this.isfromPath) {
        if (this.isObjectChanged(this.watchFrom, this.ruleForm)) {
          if (this.ruleForm.userName === '' || this.ruleForm.phone === '') {
            this.$router.go(-1);
            return;
          }
        } else {
          this.$router.go(-1);
          return;
        }
      }
      if (this.ruleForm.userName === '') {
        this.$toast({
          message: '请输入收货人名称',
          position: 'middle',
          duration: 1000,
        });
      } else if (!/^[\u4e00-\u9fa50-9A-Za-z]{2,25}$/i.test(this.ruleForm.userName)) {
        this.$toast({
          message: '收货人请输入2～25位字符，特殊字符除外!',
          position: 'middle',
          duration: 1000,
        });
      } else if (this.ruleForm.phone === '') {
        this.$toast({
          message: '请输入收货人手机号',
          position: 'middle',
          duration: 1000,
        });
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.ruleForm.phone)) {
        this.$toast({
          message: '请输入正确的手机号',
          position: 'middle',
          duration: 1000,
        });
      } else if (this.ruleForm.local === '') {
        this.$toast({
          message: '请选择城市信息',
          position: 'middle',
          duration: 1000,
        });
      } else if (this.ruleForm.address === '') {
        this.$toast({
          message: '请输入详细地址',
          position: 'middle',
          duration: 1000,
        });
        // } else if (!/^[\u4e00-\u9fa50-9A-Za-z]{0,100}$/.test(this.ruleForm.address)) {
        //   this.$toast({
        //     message: '详细地址请输入不超过100非特殊字符!',
        //     position: 'middle',
        //     duration: 1000,
        //   });
      } else {
        // this.getMergeClick();
        this.splitArea(this.ruleForm.local);
        // console.log(this.ruleForm);
        // const { active = {} } = this.$route.query;
        // if (JSON.stringify(active) !== '{}') {
        //   const { type, activityId, activityPrizeId } = active;
        //   const {
        //     userName, phone, address, local = [],
        //   } = this.ruleForm || {};
        //   const [province, city, area] = local.split(' ');
        //   const subInfo = {
        //     activityId,
        //     activityPrizeId,
        //     userName,
        //     phone,
        //     address,
        //     province,
        //     city,
        //     area,
        //   };
        //   if (type === 'daka') {
        //     reqAddDakaAddress(subInfo).then((res) => {
        //       console.log(res);
        //       if (res.code === 0) {
        //         this.$toast('添加地址成功');
        //         this.delCheck = true;
        //         this.ruleForm = {
        //           userName: '',
        //           phone: '',
        //           local: '',
        //           address: '',
        //           type: 0,
        //         };
        //         this.$router.go(-1);
        //       }
        //     });
        //   } else if (type === 'pullNew') {
        //     reqAddPullNewAddress(subInfo);
        //   }
        //   return;
        // }
        // 修改地址
        if (this.$route.query.type === 'amend') {
          this.amendAddress(this.ruleForm);
        } else {
          // 二次确认弹窗
          this.modifyAddress();
          // 新增地址
          // this.getAddAddress();
        }
      }
    },

    // 将修改事件合并到一起
    mergeClick() {
      this.splitArea(this.ruleForm.local);
      // 修改地址
      if (this.$route.query.type === 'amend') {
        this.amendAddress(this.ruleForm);
      } else {
        // 新增地址
        // this.getAddAddress();
        this.modifyAddress();
      }
    },

    // eslint-disable-next-line func-names
    getMergeClick: Throttle(function () {
      this.mergeClick();
    }, 3000),

    // 新增地址信息
    async getAddAddress() {
      if (this.loading) {
        return;
      }
      if (this.isClickCopy) {
        const {
          userName, phone, address, type,
        } = this.ruleForm;
        const addressInfo = {
          address,
          area: this.myAddresscounty,
          city: this.myAddressCity,
          phone,
          province: this.myAddressProvince,
          type,
          userName,
        };
        try {
          this.loading = true;
          const res = await reqAddAddress(addressInfo);
          this.loading = false;
          if (res.code === 0) {
            this.change = true;
            // this.$toast('新增地址成功！');
            this.isClickCopy = false;
            // this.$router.go(-1);
            this.oldAddressId = res.data;
            this.newAddressFlag = true;
            // 修改地址
            this.modifyHandoutAddress();
            // if (this?.$route?.query.onlyAddress) {
            // 订单详情页进来增加一个地址
            // 修改地址
            // this.modifyHandoutAddress();
            // } else {
            // this.modifyAddress();
            // this.modifyHandoutAddress();
            // }
          } else {
            this.isClickCopy = true;
            this.$toast('请求错误');
          }
        } catch (error) {
          this.loading = false;
          this.isClickCopy = true;
          this.$toast(error.message);
        }
      }
    },
    // 修改地址信息
    async amendAddress(data) {
      if (this.loading) {
        return;
      }
      if (this.isClick) {
        const dataInfo = JSON.parse(JSON.stringify(data));
        dataInfo.area = this.myAddresscounty;
        dataInfo.city = this.myAddressCity;
        dataInfo.province = this.myAddressProvince;
        this.$delete(dataInfo, 'local');
        try {
          this.loading = true;
          const res = await reqModifyAddress(dataInfo);
          this.loading = false;
          if (res.code === 0) {
            this.change = true;
            this.$toast('修改成功!');
            this.isClick = false;
            this.isfromPath = false;
            this.$router.go(-1);
          } else {
            this.isClick = true;
            this.$toast('请求错误！');
          }
        } catch (error) {
          this.loading = false;
          this.isClick = true;
          this.$toast(error.message);
        }
      }
    },
    // 直接选择地址
    /**
     * old：address, index
     * */
    chooseNewAddress(...params) {
      // type: 订单发货修改地址
      const [index, address, type] = params;
      this.oldChoose = index;
      this.delCheck = false;
      this.oldAddressId = type ? (address.userAddressId) : address.id;
      // this.ruleForm = {
      //   userName: address.userName,
      //   phone: address.phone,
      //   local: `${address.province} ${address.city} ${address.area}`,
      //   address: address.address,
      //   type: address.type,
      // };
      if (this?.$route?.query.onlyAddress) {
        // 订单详情页进来增加一个地址
        this.modifyHandoutAddress();
      } else {
        this.directlyChange = true;
        this.modifyAddress(type, address);
      }
    },
    async getWaitDeliver() {
      const { code, data } = await reqWaitDeliver();
      if (code === 0) {
        this.wiatNum = data;
      }
    },
    // 二次确认弹窗
    modifyAddress(type, address) {
      this.delCheck = false;

      if (this.wiatNum && !this?.$route?.query.giftPageAddress) {
        this.$dialog
          .confirm({
            confirmButtonText: '确认修改',
            confirmButtonColor: '#FF6C02',
            message: `目前有${this.wiatNum}本讲义待发货，操作修改地址后将修改所有讲义的地址`,
          })
          .then(() => {
            /**
             * 多个待发货地址修改
             *  userAddressId: false
             */
            if (type && !address.userAddressId) {
              this.addModifyAddress(address)
              return
            }
            // userAddressId: true
            if (this.directlyChange) {
              this.modifyHandoutAddress();
            } else {
              this.getAddAddress();
            }
            this.directlyChange = false;
          })
          .catch(() => {
            // on cancel
            this.delCheck = true;
            this.isClickCopy = true;
            this.directlyChange = false;
            this.oldChoose = this.chooseIndex;
            this.$refs.historyRef.currentIndex = -1;
            this.$refs.ordeRef.onClickCancel();
          });
      } else {
        this.$dialog
          .confirm({
            confirmButtonText: '确定',
            confirmButtonColor: '#FF6C02',
            message: '是否确认使用该收货信息',
          })
          .then(() => {
            if (this.directlyChange) {
              this.modifyHandoutAddress();
            } else {
              this.getAddAddress();
            }
            this.directlyChange = false;
          })
          .catch(() => {
            // on cancel
            this.delCheck = true;
            this.isClickCopy = true;
            this.directlyChange = false;
            this.oldChoose = this.chooseIndex;
          });
      }
    },

    // 多个待发货讲义地址
    async addModifyAddress(address) {
      const { addressDetail, area, city, phone, province, type, userName } = address
      const addressInfo = {
        address: addressDetail,
        area,
        city,
        phone,
        province,
        type,
        userName,
      };
      try {
        const res = await reqAddAddress(addressInfo);
        if (res?.code !== 0) return;
        this.oldAddressId = res?.data;
        await this.modifyHandoutAddress();
      } catch (error) {
        this.$toast(error.message);
      }
    },

    // 修改地址
    async modifyHandoutAddress() {
      const locationQuery = this?.$route?.query || {};
      const bindAddress = this.$route.query.changeAddress;
      if (Number(locationQuery.sourse) === 1) {
        // 讲义修改地址
        this.changeAllAddress();
        return;
      }
      if (locationQuery.giftPageAddress) {
        // 支付成功页面领取实物填写地址
        this.addGiftAdderss();
        return;
      }
      if (locationQuery.needBack) {
        this.changeAllAddress();
      } else {
        if (JSON.stringify(locationQuery) === '{}') {
          this.changeAllAddress();
          return;
        }
        if (!bindAddress && this?.$route?.query.onlyAddress) {
          const data = {
            addressId: this.oldAddressId,
            orderNo: locationQuery.orderNo,
          };
          try {
            const res = await reqIndentAddress(data);
            if (res.code === 0) {
              this.$toast('添加地址成功');
              this.delCheck = true;
              this.ruleForm = {
                userName: '',
                phone: '',
                local: '',
                address: '',
                type: 0,
              };
              this.$router.go(-1);
            } else {
              this.$toast(`添加地址失败！${res.msg}`);
            }
          } catch (error) {
            this.$toast(error.message);
          }
        }
      }
    },

    async changeAllAddress() {
      const locationQuery = this?.$route?.query || {};
      const { code } = await reqModifyReceivingAddress(this.oldAddressId);
      if (code === 0) {
        this.delCheck = true;
        this.$toast('操作成功');
        if (!this.isfromPath) {
          this.ruleForm = {
            userName: '',
            phone: '',
            local: '',
            address: '',
            type: 0,
          };
        }
        this.isfromPath = false;
        if (locationQuery.needBack) {
          console.log('99+', this.ruleForm);
          sessionStorage.setItem('addressId', this.oldAddressId);
          this.$router.go(-1);
          return;
        }

        if (this.$root.$data.isApp) {
          this.$sendToApp('closePage');
        } else {
          // 返回上一级
          this.$router.go(-1);
        }
      }
    },
    // 支付成功页面领取实物填写地址
    async addGiftAdderss() {
      const data = {
        orderNo: this?.$route?.query.orderNo,
        userAddressId: this.oldAddressId,
      };
      const res = await reqAddGiftAddress(data);
      if (res?.code === 0) {
        this.$toast('操作成功');
      } else {
        this.$toast(res.msg);
      }
      this.delCheck = true;

      if (!this.isfromPath) {
        this.ruleForm = {
          userName: '',
          phone: '',
          local: '',
          address: '',
          type: 0,
        };
      }
      this.isfromPath = false;
      sessionStorage.setItem('giftPageAddress', true);
      this.$router.go(-1);
    },

    goBack() {
      this.delCheck = true;
      if (!this.isfromPath) {
        this.ruleForm = {
          userName: '',
          phone: '',
          local: '',
          address: '',
          type: 0,
        };
      }
      this.isfromPath = false;
      if (this.$root.$data.isApp) {
        this.$sendToApp('closePage');
      } else {
        // 返回上一级
        this.$router.go(-1);
      }
    },
    // 获取地址列表
    async addressDefaultList() {
      this.chooseIndex = -1;
      const res = await reqAddressList({ pageNum: 0, pageSize: 100 });
      if (res?.code === 0) {
        const addressId = sessionStorage.getItem('addressId') || null;
        // eslint-disable-next-line no-unused-expressions
        res?.data?.data?.forEach((element, index) => {
          if (addressId) {
            if (element.id === Number(addressId)) {
              this.defauleAddress = element;
              this.chooseIndex = index;
            }
            return;
          }
          if (element.type === 1) {
            this.defauleAddress = element;
            this.chooseIndex = index;
          }
        });
        this.ruleForm = {
          userName: this.defauleAddress.userName,
          phone: this.defauleAddress.phone,
          local: this.defauleAddress.province ? `${this.defauleAddress.province} ${this.defauleAddress.city} ${this.defauleAddress.area}` : '',
          address: this.defauleAddress.address,
          type: this.defauleAddress.type || 0,
        };
        this.watchFrom = {
          userName: this.defauleAddress.userName,
          phone: this.defauleAddress.phone,
          local: `${this.defauleAddress.province} ${this.defauleAddress.city} ${this.defauleAddress.area}`,
          address: this.defauleAddress.address,
          type: this.defauleAddress.type,
        };
      }
    },
    tangLangInit() {
      // 记录进入详情页时浏览器历史记录的长度;
      this.windowHistoryLength = window.history.length;
      // 处理螳螂弹窗打开时插入历史记录的问题
      let target;
      const time = setInterval(() => {
        target = document.getElementById('mantisChatBox');
        if (target) {
          // eslint-disable-next-line consistent-return
          this.mutationObserverVal = new MutationObserver(() => {
            if (
              target.style.display === 'none'
              && window.history.state.url === window.location.href
            ) {
              const num = window.history.length - this.windowHistoryLength;
              if (num > 0) {
                window.history.go(-num);
                return false;
              }
            }
          });
          this.mutationObserverVal.observe(target, { attributeFilter: ['style'], subtree: true });
          clearInterval(time);
        }
      }, 500);
    },
  },
  // 离开路由之前执行的函数
  beforeRouteLeave(to, from, next) {
    if (to.name === 'address') {
      // 以此来判断回列表也是否需要重新请求数据
      const that = to;
      that.meta.isUseCache = !this.change;
    }
    next();
  },
  // 进入之前改变meta的title
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const that = vm;
      if (to.query.type === 'amend') {
        that.title = '修改收货地址';
        document.title = '修改收货地址';
      }
      if (from.path === '/payOrder') {
        that.isfromPath = true;
      }
    });
  },
};

</script>
<style lang="scss" scoped>
.newAdress {
  position: absolute;
  width: 100%;
  min-height: 100%;
  padding-top: 120px;
  color: $fontColorBlack;
  background: #f9f9f9;

  &.inApp {
    padding-top: 33px;
  }

  &-body {
    padding: 0 36px 36px;
    background: #f9f9f9;

    .adressTitle {
      padding: 28px 0 25px;
      color: #787878;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }

    ::v-deep .van-cell {
      &::after {
        border-bottom: none;
      }

      .van-field__label {
        span {
          color: $fontColorBlack;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    .content {
      .first-field {
        padding-top: 43px;
        border-radius: 14px 14px 0 0;
      }

      .four-field {
        // border-radius: 0 0 14px 14px;
      }
    }

    .default {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      height: 100px;
      padding: 0 36px;
      font-weight: 400;
      font-size: 25px;
      background-color: $bgWhite;
      border-radius: 0 0 14px 14px;

      .img-icon {
        width: 36px;
        height: 36px;
      }

      ::v-deep .van-radio__label {
        color: #787878;
      }

      // border-radius: 14px;
    }

    .footer {
      position: fixed;
      bottom: 26px;
      left: 50%;
      z-index: 11;
      width: 88%;
      transform: translate(-50%, 0);

      ::v-deep .van-button {
        &--block {
          height: 48px;
        }

        &--info {
          background-color: $theme_color;
          border: 1px solid $theme_color;
        }
      }

      ::v-deep .van-button__text {
        font-size: 18px;
        line-height: 25px;
      }

      .button {
        @include commonBtn(100%, 91px, $theme_color, 45px, 36px, $bgWhite);

        font-weight: normal;
      }
    }
  }
}
</style>
